"use client"

import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer, Legend } from "recharts"

const data = [
  {
    feature: "Conversion",
    "Youzu Lens": 80,
    "Room Visualizer": 90,
    "Magic Background": 70,
    "2D to 3D": 85,
  },
  {
    feature: "Engagement",
    "Youzu Lens": 85,
    "Room Visualizer": 95,
    "Magic Background": 65,
    "2D to 3D": 80,
  },
  {
    feature: "Retention",
    "Youzu Lens": 75,
    "Room Visualizer": 85,
    "Magic Background": 60,
    "2D to 3D": 70,
  },
  {
    feature: "ROI",
    "Youzu Lens": 90,
    "Room Visualizer": 80,
    "Magic Background": 75,
    "2D to 3D": 95,
  },
  {
    feature: "User Growth",
    "Youzu Lens": 70,
    "Room Visualizer": 75,
    "Magic Background": 80,
    "2D to 3D": 65,
  },
]

export function AnalyticsFeatureComparison() {
  return (
    <div className="h-[300px] w-full">
      <ResponsiveContainer width="100%" height="100%">
        <RadarChart data={data}>
          <PolarGrid />
          <PolarAngleAxis dataKey="feature" />
          <PolarRadiusAxis angle={30} domain={[0, 100]} />
          <Radar name="Youzu Lens" dataKey="Youzu Lens" stroke="#FF4D8C" fill="#FF4D8C" fillOpacity={0.2} />
          <Radar name="Room Visualizer" dataKey="Room Visualizer" stroke="#9D4EDD" fill="#9D4EDD" fillOpacity={0.2} />
          <Radar name="Magic Background" dataKey="Magic Background" stroke="#4CC9F0" fill="#4CC9F0" fillOpacity={0.2} />
          <Radar name="2D to 3D" dataKey="2D to 3D" stroke="#F3A712" fill="#F3A712" fillOpacity={0.2} />
          <Legend />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  )
}
